import React, { useEffect, useRef, useState } from "react";
import bwipjs from "bwip-js";
import jsPDF from "jspdf";

const ProductoDetail = ({ producto, agregarAlCarrito, carrito }) => {
  const barcodeRef = useRef(null);

  const [codigoBarras, setCodigoBarras] = useState(producto.codigoBarras || "");
  

  const [cantidad, setCantidad] = useState(1);

  const handleAgregar = () => {
    // Validar que la cantidad sea mayor a 0
    if (cantidad <= 0) {
      alert("Por favor, selecciona al menos una unidad.");
      return;
    }

    // Calcular la cantidad acumulada en el carrito
    const cantidadEnCarrito = carrito
      .filter((item) => item.id === producto.id)
      .reduce((total, item) => total + item.cantidad, 0);

    const cantidadDisponible = producto.stock - cantidadEnCarrito;

    if (cantidad <= cantidadDisponible) {
      agregarAlCarrito({ ...producto, cantidad });
    } else {
      alert(
        `Solo puedes agregar hasta ${cantidadDisponible} unidades de este producto.`
      );
    }
  };

  // Generar el código de barras cuando el componente se monte
  useEffect(() => {
    if (producto && producto.codigoBarras) {
      try {
        bwipjs.toCanvas(barcodeRef.current, {
          bcid: "code128", // Tipo de código de barras
          text: producto.codigoBarras, // El código de barras
          scale: 2, // Escalado del tamaño
          height: 8, // Altura del código
          includetext: true, // Incluir el texto debajo del código
          textxalign: "center", // Alineación del texto
        });
      } catch (e) {
        console.error(e);
      }
    }
  }, [producto]);

  // Función para generar el ticket en PDF
  const generarTicket = () => {
    const doc = new jsPDF();

    // Estilo del ticket
    doc.setFontSize(12);
    doc.text(20, 20, `Producto: ${producto.nombre}`);
    doc.text(20, 30, `Descripción: ${producto.descripcion}`);
    doc.text(20, 40, `Categoría: ${producto.categoria.nombre}`);
    // doc.text(20, 50, `Proveedor: ${producto.proveedor.nombre}`);
    doc.text(20, 50, `Devolucion: ${producto.esPrestamo ? "si" : "no"}`);
    doc.text(20, 60, `Stock Disponible: ${producto.stock}`);
    doc.text(20, 70, `Código de Barras:`);

    // Convertir canvas a imagen y agregar al PDF
    const barcodeCanvas = barcodeRef.current;
    if (barcodeCanvas) {
      const barcodeImage = barcodeCanvas.toDataURL("image/png");
      doc.addImage(barcodeImage, "PNG", 20, 85, 150, 40); // Añadir imagen de código de barras
    }
    doc.autoPrint({ variant: "non-conform" });
    // Descargar el PDF
    doc.save(`ticket_${producto.nombre}.pdf`);
  };

  return (
    // <div className=" border border-slate-400 rounded-lg ">
    <tr className="px-6 dark:hover:bg-gray-900">
      <td className="border-zinc-800 text-white p-2">{producto?.nombre}</td>
      <td className="border-zinc-800 text-white p-2">
        {producto?.categoria?.nombre}
      </td>
      <td className="border-zinc-800 text-white p-2">
        <input
          type="number"
          className=" bg-slate-900 text-center text-white "
          value={cantidad}
          onChange={(e) => setCantidad(Number(e.target.value))}
          min="0"
          max={producto.stock}
        />
      </td>
      <td className="border-zinc-800 text-white p-2">{producto?.stock}</td>
      <td className="border-zinc-800 text-white p-2">{producto?.unidadMedida}</td>
      <td className="border-zinc-800 text-white p-2">
        <button
          onClick={handleAgregar}
          className="bg-green-500 text-xs text-white px-2 py-1 rounded-xl"
        >
          Agregar al Carrito
        </button>
      </td>
    </tr>

    //   <div className="mt-4">
    //     <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
    //       Categoria: {producto.categoria.nombre}
    //     </h3>
    //     <h2 className="text-gray-900 title-font text-lg font-medium">
    //       {producto.nombre}
    //     </h2>
    //     <p className="mt-1">Prestable: {producto.esPrestamo ? "Si" : "No"}</p>
    //     <p className="mt-1">Stock: {producto.stock}</p>
    //     <p className="inline-flex flex-col xl:flex-row xl:items-center text-gray-800">
    //       Código de Barras:
    //     </p>
    //     <canvas ref={barcodeRef} className="hidden"/>
    //   </div>
    //   <span className="inline-flex mt-3 ml-3 px-2 py-1 rounded-lg z-10 bg-red-500 text-sm font-medium text-white select-none">
    //     <button onClick={generarTicket}>Generar Ticket</button>
    //   </span>
    //   <div className="mt-2">
    //     <label htmlFor={`cantidad-${producto.id}`} className="block text-sm">
    //       Cantidad:
    //     </label>
    //     <input
    //     type="number"
    //     value={cantidad}
    //     onChange={(e) => setCantidad(Number(e.target.value))}
    //     min="0"
    //     max={producto.stock}
    //   />
    //   </div>
    //   <button
    //     onClick={handleAgregar}
    //     className="bg-green-500 text-white px-4 py-2 mt-2 rounded"
    //   >
    //     Agregar al Carrito
    //   </button>
    // </div>
  );
};

export default ProductoDetail;
